import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10 15.1701L6.83 12.0001L10 8.83012L10 10.0001L18 10.0001L18 14.0001L10 14.0001L10 15.1701ZM12 20.0001L12 16.0001L20 16.0001L20 8.00012L12 8.00012L12 4.00012L4 12.0001L12 20.0001Z" fill="#606060"/>
</svg>
;
